import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ScatterPlotChartComponent } from './scatter-plot-chart.component';
import type { ScatterPlotDisplayConfig, ScatterPlotParams, ScatterPlotPrediction } from './scatter-plot-chart.model';
import { computeRegression, predictY } from './scatter-plot-chart.util';

@Component({
  selector: 'dojo-scatter-plot-explain',
  standalone: true,
  imports: [ScatterPlotChartComponent],
  template: `<dojo-scatter-plot-chart [params]="params()" [display]="display()" [prediction]="activePrediction()" />`,
  host: { class: 'block w-full h-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScatterPlotExplainComponent {
  readonly params = input.required<ScatterPlotParams>();
  readonly display = input<ScatterPlotDisplayConfig>({});
  readonly prediction = input<ScatterPlotPrediction | null>(null);

  readonly activePrediction = computed<ScatterPlotPrediction | null>(() => {
    const explicit = this.prediction();
    if (explicit) {
      return explicit;
    }

    const predictX = this.display().predictX;
    if (predictX === null || predictX === undefined) {
      return null;
    }

    const regression = computeRegression(this.params().points);
    if (!regression) {
      return null;
    }

    return { x: predictX, y: predictY(regression, predictX) };
  });
}
